import React        from 'react'
import Arrow        from "./Vector.svg"    

const Details = props => {
    return (
        <div className="services-details-container-content-details">
            <div className="header">
                <div className="header-title">
                    <h1>Denetim Hizmetleri</h1>
                    <p>Lorem Ipsum is simply dummy text  of the printing and typesetting industry of the printing and typesetting industry.</p>
                </div>
                <img className='header-img' src="https://picsum.photos/200/300" />
            </div>
            <div className="content">
                <img className="content-arrow" src={ Arrow }/>
                <p> Dördüncü dalgası içinde olduğumuz söylenen Kovid ile alakalı tam anlamıyla bir hasar raporu henüz çıkmadı. Ancak büyük kurumlardan çeşitli açıklamalar geliyor elbette. Fed de son açıklamasında desteğe devam edeceğini söyledi. Yani toparlanma düşündüğümüzden daha uzun sürecek. Hatırlarsanız geçen yıl Havayolu Şirketleri v
e Havayolu Taşımacılığı ile ilgili “en erken 2021 son çeyrekte toparlanır” şeklinde açıklamalar yapmıştım. Bu bile iyimser bir yaklaşım olarak değerlendirilebilir. Bir örnekle açıklayayım: Heathrow Havalimanı’ndan yapılan açıklamada, 2020 yılında havalimanını ziyaret eden toplam yolcu sayısının 22,1 milyon olduğu, 2021 yılında ise 21,5 milyon yolcunun havalimanını ziyaret etmesinin beklendiği kaydedildi. Yani geçen 
yıldan daha az kişi gelecek. Halbuki bu yıl toparlanma yılı olacaktı. Şunu da hatırlatayım: 2019 yılında ise toplam 90 milyon yolcu Heathrow Havalimanını kullanmıştı. İnanılmaz ve üzücü bir durum. Yaptıkları hesaba göre, 2021 yılının ilk yarısında Heathrow Havalimanı toplam 2,9 milyar ste
                </p>
            </div>
        </div>
    )
}

export default Details
